export const TEST_ID = 'homePointPinIcon';
